import { render, staticRenderFns } from "./FriendList.vue?vue&type=template&id=27903eb2&scoped=true&"
import script from "./FriendList.vue?vue&type=script&lang=js&"
export * from "./FriendList.vue?vue&type=script&lang=js&"
import style0 from "./FriendList.vue?vue&type=style&index=0&id=27903eb2&lang=scss&scoped=true&"
import style1 from "./FriendList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27903eb2",
  null
  
)

export default component.exports